module.exports = __webpack_public_path__ + "img/shape_triangle_checked.f5e2cc02.png";